// extracted by mini-css-extract-plugin
export default {"reportSectionRow":"ReportSectionWrapper_reportSectionRow__MmJX5"};